import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import messagesApi from '@/features/dashboard/messages/api/messagesApi.ts';
import {
  isScopedMessagesQueryKey,
  messagesApiQueryKeys,
} from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';

/** Z `tourId` (tabela wyjazdu) panel spraw tego wyjazdu gubi „Niewysłane wiadomości” od razu. */
const useRetryMessage = (tourId?: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id) => messagesApi.retryMessage(id),
    onSuccess: () => {
      toast.success('Wiadomość wróciła do wysyłki');
      // Dialog zamyka się dopiero po odświeżeniu listy — inaczej wiersz dalej
      // pokazuje FAILED, a drugie kliknięcie kończy się 409.
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: messagesApiQueryKeys.all() }),
        queryClient.invalidateQueries({
          predicate: (query) => isScopedMessagesQueryKey(query.queryKey),
        }),
        invalidateAttentionQueries(queryClient, tourId),
      ]);
    },
    onError: (error: Error) => {
      toast.error('Nie udało się ponowić wysyłki', {
        description: error.message,
      });
    },
  });
};

export default useRetryMessage;
